import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FormDataContextType {
  formData: unknown;
  setFormData: (data: unknown) => void;
}

const FormDataContext = createContext<FormDataContextType | undefined>(undefined);

export const useFormData = () => {
  const context = useContext(FormDataContext);
  if (context === undefined) {
    throw new Error('useFormData must be used within a FormDataProvider');
  }
  return context;
};

interface FormDataProviderProps {
  children: ReactNode;
  initialData?: unknown;
}

export const FormDataProvider: React.FC<FormDataProviderProps> = ({
  children,
  initialData = null,
}) => {
  const [formData, setFormData] = useState<any>(initialData);

  return (
    <FormDataContext.Provider value={{ formData, setFormData }}>
      {children}
    </FormDataContext.Provider>
  );
};
